import {_} from 'lodash';
import {ISyncField} from '../../index';
import {template as tpl, viewModel as SelectBaseViewModel} from "./base";
import {ISelectParams} from "./index";
import {ObjectTypeId} from "../../constants";
import {nsSyncFields} from "../../req/nsSyncFields";
import {getObjectDefinition, getSourceTranslation} from "../../util/misc";
import {storeObservable} from "../../util/sessionstore";
import {TSearchParams} from "../../util/request";

export let template = tpl;

interface IParams<ISyncField> extends ISelectParams<ISyncField> {
    api: undefined
    objectTypeIds: ObjectTypeId | ObjectTypeId[]
}

export class viewModel extends SelectBaseViewModel<ISyncField> {
    constructor(params: IParams<ISyncField>) {
        super(_.defaultsDeep(params, {
            api: {
                promiseRequest: nsSyncFields.getSyncFieldsPromiseRequest(),
                params: {objectTypeIds: params.objectTypeIds},
            },
            key: 'syncfieldid',
            options: {
                text: (sf: ISyncField) => this.getSyncFieldText(sf),
                title: (sf: ISyncField) => this.getSyncFieldTitle(sf),
            },
            sortBy: (sf: ISyncField) => this.syncfieldsSortBy(sf),
        }));

        this.kosub.subscribe(storeObservable('language'), () => this.request())
    }

    protected override getApiParams(): TSearchParams {
        const ret = super.getApiParams() as any
        ret.languageid = storeObservable('language')().id
        return ret
    }

    private getSyncFieldText(sf: ISyncField): string {
        if (!sf) {
            return '';
        }
        let ret = getSourceTranslation(sf);
        if (![ObjectTypeId.User, ObjectTypeId.Department, ObjectTypeId.Group, ObjectTypeId.FormData].includes(sf.objecttypeid)) {
            ret += '*';
        }
        return ret;
    }

    private getSyncFieldTitle(sf: ISyncField): string {
        storeObservable('show.source.translations')
        if (!sf) {
            return '';
        }
        let ret = sf.description || sf.name;
        const def = getObjectDefinition(sf.objecttypeid);
        if (def) {
            ret += ` (${def.singular})`;
        }
        return ret;
    }

    private syncfieldsSortBy(sf: ISyncField) {
        return getSourceTranslation(sf);
    }

}
